import type { ReactNode } from 'react';

interface Props {
    reference: string;
    badges: ReactNode;
    startDate: string;
    availableBalance: string | null;
    leftToPay?: string | null;
}

const headingId = 'agreement-header-heading';

export function AgreementHeaderLayout({ reference, badges, startDate, availableBalance, leftToPay }: Props) {
    return (
        <section aria-labelledby={headingId} className="space-y-2">
            <h2 id={headingId} className="sr-only">
                Agreement identity and status
            </h2>
            <div className="flex flex-wrap items-center gap-3">
                <span className="font-mono text-lg font-semibold text-mp-foreground">{reference}</span>
                {badges}
            </div>
            <dl className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm sm:flex sm:gap-8">
                <div>
                    <dt className="text-xs uppercase tracking-wide text-mp-muted">Start date</dt>
                    <dd className="text-mp-foreground">{startDate}</dd>
                </div>
                <div>
                    <dt className="text-xs uppercase tracking-wide text-mp-muted">Available balance (inc VAT)</dt>
                    <dd className="text-mp-foreground">{availableBalance ?? '—'}</dd>
                </div>
                {leftToPay != null && (
                    <div>
                        <dt className="text-xs uppercase tracking-wide text-mp-muted">Left to pay</dt>
                        <dd className="text-mp-foreground">{leftToPay}</dd>
                    </div>
                )}
            </dl>
        </section>
    );
}
